import { css, html, LitElement } from "lit";
import { customElement, property } from "lit/decorators";
import { ifDefined } from 'lit/directives/if-defined.js';

import {
  containerStyles, moduleSpacingStyles,
  normalizeStyles,
  typographyStyles,
} from '@webs/components-library/theming';
import {PropertyValues} from 'lit-element';

@customElement("webs-text-multiple-columns")
export class TextMultipleColumns extends LitElement {
  static styles = [
    normalizeStyles,
    moduleSpacingStyles,
    containerStyles,
    typographyStyles,
    css`
      .m-text-multiple-columns .spaced .item { margin-top: 1.6rem; }
      .m-text-multiple-columns .content ::slotted(p) {
        font-family: var(--font-family-base);
        color: #0b0d17;
        font-weight: var(--font-weight-base);
      }

      .m-text-multiple-columns .content ::slotted(p):last-of-type { margin-bottom: 0; }

      .m-text-multiple-columns ::slotted([slot="title"]) {
        margin-bottom: 0 !important;
      }

      @media only screen and (min-width: 992px){
      .m-text-multiple-columns .spaced .item { margin-top: 2rem; }
      }
    `,
  ];

  private hasTitle: boolean;

  @property({attribute: 'space-top'})
  spaceTop = 'm';

  @property({attribute: 'space-bottom'})
  spaceBottom = 'm';

  @property()
  id: string;

  @property()
  amountOfColumns: string;

  protected render(): unknown {
    return html`
      <section id="${ifDefined(this.id)}" class="m-text-multiple-columns ${this.spaceTop ? 'module_top-padding-' + this.spaceTop : ''} ${this.spaceBottom ? 'module_bottom-padding-' + this.spaceBottom : ''}">
        <div part="container" class="container">

            <webs-grid-row class="row">
              <webs-grid-column class="intro-title" md="8" lg="5">
                <slot name="title"></slot>
            </webs-grid-column>
          </webs-grid-row>
          <div class="content ${this.hasTitle ? 'spaced': ''}">
            <webs-grid-row>
              <webs-grid-column
                sm="6"
                lg="${this.amountOfColumns == "2" ? "6" : "4"}"
                class="item"
              >
                <slot name="col-1"></slot>
              </webs-grid-column>
              <webs-grid-column
                sm="6"
                lg="${this.amountOfColumns == "2" ? "6" : "4"}"
                class="item"
              >
                <slot name="col-2"></slot>
              </webs-grid-column>
              <webs-grid-column
                sm="6"
                lg="${this.amountOfColumns == "2" ? "6" : "4"}"
                class="item"
              >
                <slot name="col-3"></slot>
              </webs-grid-column>
            </webs-grid-row>
          </div>
        </div>
      </section>
    `;
  }

  protected firstUpdated(_changedProperties: PropertyValues) {
    super.firstUpdated(_changedProperties);
    const titleContainer: HTMLElement = this.shadowRoot.querySelector('.intro-title');
    const titleSlots = titleContainer.querySelector('slot').assignedElements();
    this.hasTitle = titleSlots.length > 0;

    this.requestUpdate();
  }
}
